export function setItem(key: string, value: any) {
  if (value) {
    window.localStorage.setItem(key, value);
  }
}
